/** An experiment's dataset as "Name v3"; just the name while a run on fresh traces has no version (or its pull failed). */
export function datasetLabel(d: { name: string; version: number | null }, sep = " "): string {
  return d.version == null ? d.name : `${d.name}${sep}v${d.version}`;
}
